import * as R from "ramda";

import { PollFormModel, PollModel } from "../../types";

export const convertPoolFormRequest = (poll: PollFormModel & { personaId: number }): PollModel => ({
	...R.pick(["description", "answer", "duration", "personaId"], poll),
	mode: poll.mode ? "multiple" : "single"
});
